Dom.addComponent(new class AlertComponent extends AbstractComponent {

  constructor() {
    super({
      name: "alert",
      iframable: true,
      responsiveChildren: {
        width: false,
        height: true
      }
    });
  }

  css() {
    return `GULP-CSS-FILE-ALERT`;
  }

  html(props) {
    return `
      <div class="slaask-hidden">
        <div id="slaask-alert-header" class="slaask-alert-header" style="color: ${this.app._title_color}!important; background-color: ${this.app._window_color}!important;"></div>
        <div id="slaask-alert-header-cross" class="slaask-alert-header-cross">${Svg.cross('#444444', 12)}</div>
        <div id="slaask-alert-content" class="slaask-alert-content">
          <div id="slaask-alert-title" class="slaask-alert-title"></div>
          <div id="slaask-alert-content-box" class="slaask-alert-content-box-box "></div>
          <div id="slaask-alert-input-box" class="slaask-alert-input-box slaask-hidden">
            <input type="email" required="required" class="slaask-alert-input" id="slaask-alert-input" />
            <br />
            <input type="text" class="slaask-alert-input-firstname slaask-hidden" id="slaask-alert-input-firstname" placeholder="Firstname" />
            <input type="text" class="slaask-alert-input-lastname slaask-hidden" id="slaask-alert-input-lastname" placeholder="Lastname" />
          </div>
        </div>
        <div id="slaask-alert-cta" class="slaask-alert-cta">
          <a id="slaask-alert-cancel" class="cancel" href="#" style="border: 1px solid ${this.app._window_color}!important;">
            Cancel
          </a>
          <a id="slaask-alert-cta-button" href="#" style="border: 1px solid ${this.app._window_color}!important;">
            Click here!
          </a>
        </div>
      </div>
    `;
  }

});
